<template>
  <el-dialog title="学校变更记录" :visible.sync="dialogVisible">
    <el-table border :data="logData" v-loading="loading" class="tableList">
      <el-table-column property="school_name" label="申请学校"></el-table-column>
      <el-table-column property="teacher.truename" label="操作人" width="200"></el-table-column>
      <el-table-column property="create_time" label="操作时间"></el-table-column>
    </el-table>
  </el-dialog>
</template>
<script>
export default {
  name: 'SchoolHistoryList',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      logData: [],
    };
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        this.dialogVisible = newValue;
        this.getLogs();
      }
    },
    dialogVisible(newValue) {
      this.$emit('update:visible', newValue);
    }
  },
  methods: {
    async getLogs() {
      this.loading = true;
      const { data } = await this.$http._post({
        url: '/interview/plan/schoolChangeLogs',
        data: {
          userId: this.$route.params.id
        }
      });
      this.logData = data;
      this.loading = false;
    }
  },
  destroyed() {
    this.dialogVisible = false;
  },
};
</script>
